module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/email-extension-1-notif.gif"